'use client';

export default function HomepageBenefitsBar() {
  return (
    <div className="bg-light-surface dark:bg-surface border-y border-light-border dark:border-border py-4 mb-8">
      <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-light-text-secondary dark:text-foreground-secondary" role="list">
        <div className="flex items-center gap-2" role="listitem">
          <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Feature available">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span>Save & organize content</span>
        </div>
        <div className="flex items-center gap-2" role="listitem">
          <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Feature available">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span>Track learning paths</span>
        </div>
        <div className="flex items-center gap-2" role="listitem">
          <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Feature available">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span>24+ interactive tools</span>
        </div>
        <div className="flex items-center gap-2" role="listitem">
          <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Feature available">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span>Personalized recommendations</span>
        </div>
      </div>
    </div>
  );
}
